<template>
  <div id="RechargeOnline">
    <div class="recharge-online-content" v-loading="loadingStatus">
      <div class="common-header">
        <es-breadcrumb>
          <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
          <es-breadcrumb-item>{{ $t('在线支付') }}</es-breadcrumb-item>
        </es-breadcrumb>
      </div>
      <divided />

      <div class="balance-bar">
        <p class="title">
          <span class="left">{{ $t('需支付金额:') }}</span>
          <span v-show="fee > 0">{{ needPay }}&nbsp;{{ $t('元') }}&nbsp;+&nbsp;{{ fee }}{{ $t('元 (快递费)') }}&nbsp;=</span>
          <span class="money">{{ amount.toFixed(2) }}</span
          >{{ $t('元') }}
        </p>
        <p class="a-link" v-if="isPostPaid" @click="checkHistoryList()">{{ $t('查看历史结算详单') }}</p>
      </div>
      <div class="diy-selecter-area">
        <es-radio-group v-model="paymentWay" style="width: 100%">
          <ECollapse
            :active="paymentWay === 'balance'"
            :disabled="hasBalance"
            class="margin-bottom-20"
            v-show="userInfo.realName && myWallet > 0 && userInfo.isAdmin && !isPartner"
          >
            <div class="rower" slot="title">
              <es-radio :disabled="hasBalance" :label="'balance'">{{ $t('使用余额支付') }}</es-radio>
              <p>
                {{ $t('我的账户余额:') }}
                <span style="color: #f00f">{{ myWallet }}</span>
                >{{ $t('元') }}
              </p>
            </div>
            <div class="e-collapse-content">
              <p class="label">{{ $t('签署密码') }}</p>
              <div class="flex-row-start-center">
                <input style="opacity: 0; position: absolute; width: 0; height: 0" />
                <input type="password" style="opacity: 0; position: absolute; width: 0; height: 0" />
                <es-input
                  v-model="signPassword"
                  class="width-200"
                  size="middle"
                  type="password"
                  autocomplete="off"
                  :placeholder="$t(`请输入签署密码进行支付`)"
                ></es-input>
                <p class="explain">{{ $t('还没有签署密码?') }}</p>
                <p class="a-link explain" @click="locationTo($Dic.getDefaultURL().setPwdUrl)">{{ $t('去设置签署密码') }}</p>
              </div>
            </div>
          </ECollapse>
          <ECollapse :active="paymentWay === 'other'" class="margin-bottom-20">
            <div slot="title">
              <es-radio :label="'other'">{{ $t('使用第三方支付') }}</es-radio>
            </div>
            <div class="e-collapse-content">
              <p class="label">{{ $t('支付方式') }}</p>
              <div class="payment-way">
                <div class="payment-block" :class="{ active: paymentOthWay === 'alipay' }" @click="handlePaymentOthWayClick('alipay')">
                  <img src="./../../assets/payment/Alipay.png" draggable="false" :alt="$t(`支付宝`)" />
                </div>
              </div>
              <div class="payment-way">
                <div class="payment-block" :class="{ active: paymentOthWay === 'wei' }" @click="handlePaymentOthWayClick('wei')">
                  <img src="./../../assets/icons/wei.svg" draggable="false" :alt="$t(`微信`)" class="wei" />
                </div>
              </div>
            </div>
          </ECollapse>
          <ECollapse :active="paymentWay === 'bank'">
            <div slot="title">
              <es-radio :label="'bank'">{{ $t('对公支付') }}</es-radio>
            </div>
            <div class="e-collapse-content">
              <p class="label">{{ $t('支付方式') }}</p>
              <div class="payment-way">
                <div class="payment-block bank" :class="{ active: paymentOthWay === 'bank' }" @click="handlePaymentOthWayClick('bank')">
                  <img src="./../../assets/icons/bank.png" style="width: 40px; height: 40px" draggable="false" :alt="$t(`银行转账`)" />
                  <div style="width: 90px; line-height: 40px; height: 40px; color: rgb(0 0 0); font-size: 16px">{{ $t('银行转账') }}</div>
                </div>
              </div>
            </div>
          </ECollapse>
        </es-radio-group>
        <es-button type="primary" style="margin: 10px 24px" @click="handleConfirmPayment()" :loading="loadingStatus">{{
          $t('确认支付')
        }}</es-button>
      </div>
    </div>

    <es-dialog :title="$t(`历史结算清单`)" :visible.sync="historyBillListDialogShow">
      <p>
        <es-table :data="tableData" style="width: 100%">
          <template slot="empty"
            ><es-empty
              style="margin: 25px; color: #999; line-height: 40px"
              :description="$t(`暂无更多数据`)"
              image="data:image/png;base64,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"
            ></es-empty>
          </template>
          <es-table-column :label="$t(`支付记录号`)">
            <template slot-scope="scope">{{ scope.row.payRecordId || '--' }}</template>
          </es-table-column>
          <es-table-column prop="produceCost" :label="$t(`费用`)"></es-table-column>
          <es-table-column prop="produceStartTime" :label="$t(`结算周期`)">
            <template slot-scope="scope">
              <p>{{ scope.row.produceYear + '-' + scope.row.produceMonth }}</p>
            </template>
          </es-table-column>

          <es-table-column prop="status" :label="$t(`支付状态`)">
            <template slot-scope="scope">
              <p>{{ dictPaymentStatus[scope.row.status] || '--' }}</p>
            </template>
          </es-table-column>
        </es-table>
      </p>

      <div slot="footer">
        <es-button variant="outline" @click="historyBillListDialogShow = false">{{ $t('取消') }}</es-button>
        <es-button type="primary" @click="historyBillListDialogShow = false">{{ $t('确定') }}</es-button>
      </div>
    </es-dialog>
    <es-dialog :title="payTitle" :visible.sync="qrCodeDialogShow" @close="clearClock">
      <div style="text-align: center">
        <vue-qr :text="qrCode" :size="200"></vue-qr>
      </div>
    </es-dialog>
    <es-dialog
      :title="$t(`专属汇款账号`)"
      :visible.sync="bankPayDialogShow"
      :esign-loading-text="$t(`证明文件正在生成中，请勿关闭当前页面`)"
      v-loading="loading"
    >
      <div style="padding: 2% 3%">
        {{
          $t(
            '平台收到银行汇款后十分钟内将自动匹配到您的订单，并为您完成支付。注：专属汇款账号是在平台发票信息显示账号下设立的子账号，二者为同一账号。'
          )
        }}
      </div>
      <div style="padding: 3%; background: #f3f3f3">
        <div style="color: red; padding: 1% 2%">{{ $t('您选择对公支付，请使用企业账户汇款，如使用个人账户可能有失败风险！') }}</div>

        <div style="padding: 1% 2%">
          <span style="display: inline-block; width: 100px; text-align: right; font-weight: bold">{{ $t('开户名称：') }}</span
          ><span>{{ bankPay.companyName || '--' }}</span>
        </div>
        <div style="padding: 1% 2%">
          <span style="display: inline-block; width: 100px; text-align: right; font-weight: bold">{{ $t('开户银行：') }}</span
          ><span>{{ bankPay.bankName || '--' }}</span>
        </div>
        <div style="padding: 1% 2%">
          <span style="display: inline-block; width: 100px; text-align: right; font-weight: bold">{{ $t('专属汇款账号：') }}</span
          ><span>{{ bankPay.bankAccountNo || '--' }}</span>
        </div>
      </div>
      <div style="padding: 2% 5%">
        <es-button type="text" v-clipboard:success="copySuccess" v-clipboard:copy="copyValue" :key="copyValue">{{
          $t('一键复制账户信息')
        }}</es-button>
        <es-button type="text" @click="download">{{ $t('下载专属帐号电子证明') }}</es-button>
      </div>

      <div style="text-align: center; padding: 2%" v-if="orderSource !== 2">
        {{ $t('您选择对公支付，需要在72小时内完成汇款到账，超过时订单将会关闭，请勿多汇款或少汇款！') }}
      </div>
      <template slot="footer">
        <es-button type="primary" @click="sureBankPay">{{ $t('确定') }}</es-button>
        <es-button variant="outline" @click="bankPayDialogShow = false">{{ $t('取消') }}</es-button>
      </template>
    </es-dialog>
    <div v-html="apply" ref="apply"></div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import MD5 from 'js-md5'
import ECollapse from '@/components/ECollapse.vue'
import { mapState } from 'vuex'
import { debounce } from '@/util.js'
import divided from '../../components/divided'
import vueQr from 'vue-qr'
import tsignDataTrack from '@tsign/tsigndata-sdk-js'
import { orderSourceMap } from '@esign/esign-client-jssdk'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isPartner: state => state.isPartner,
      isOrg: state => state.isOrg,
    }),
    sourceChannel() {
      return Number(sessionStorage.getItem('source_channel')) || 0
    },
    orderSource() {
      return this.orderInfo.orderSource
    },
  },
  name: 'RechargeOnline',
  components: {
    ECollapse,
    divided,
    vueQr,
  },
  data() {
    return {
      ouid: '',
      loadingStatus: false,
      orderInfo: {},
      loading: '',
      payTitle: $t('微信支付(请用微信扫描二维码)'),
      copyValue: '',
      bankPayDialogShow: false,
      clock: null,
      qrCodeDialogShow: false,
      qrCode: '',
      needPay: 0,
      fee: 0,
      amount: 0,
      payOrderId: null,
      expressFee: 0,
      paymentOthWay: 'alipay',
      paymentWay: 'balance',
      hasBalance: false,
      signPassword: '',
      routerQuery: {},
      historyBillListDialogShow: false,
      isPostPaid: false,
      tableData: [],
      myWallet: null,
      apply: '',
      dictPaymentStatus: [$t('未支付'), $t('支付成功')],
      currentInvoiceId: '',
      bankPay: {},
    }
  },
  filters: {
    formatDate(val) {
      const curTime = new Date(val)
      const TEN = 10
      const ONE = 1
      const yyyy = curTime.getFullYear()
      const MM = curTime.getMonth() + ONE < TEN ? `0${curTime.getMonth() + ONE}` : curTime.getMonth() + ONE
      const dd = curTime.getDate() < TEN ? `0${curTime.getDate()}` : curTime.getDate()

      const hh = curTime.getHours() < TEN ? `0${curTime.getHours()}` : curTime.getHours()
      const mm = curTime.getMinutes() < TEN ? `0${curTime.getMinutes()}` : curTime.getMinutes()
      const ss = curTime.getSeconds() < TEN ? `0${curTime.getSeconds()}` : curTime.getSeconds()

      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`
    },
  },
  watch: {
    paymentWay() {
      if (this.paymentWay === 'bank') {
        this.paymentOthWay = 'bank'
      }
    },
  },
  async mounted() {
    this.ouid = localStorage.getItem('ouid')
    this.routerQuery = this.$router.currentRoute.query
    await this.pageInit()
  },
  destroyed() {
    this.clearClock()
  },
  methods: {
    reportSourceChannel(type) {
      const personOid = localStorage.getItem('ouid')
      const personGid = localStorage.getItem('guid')
      const data = {
        commodity_number: this.orderInfo.totalNum,
        commodity_name: this.orderInfo.commodityName,
        commodity_id: this.orderInfo.commodityId,
        user_type: this.isOrg ? '企业' : '个人',
        oid: this.isOrg ? this.userInfo.orgId : personOid,
        gid: this.isOrg ? this.userInfo.gid : personGid,
        pay_amount: this.amount?.toFixed(2) || '0.00',
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap[this.sourceChannel] || 'other',
        order_id: this.orderInfo.showId,
      }
      tsignDataTrack.track(type, data)
    },
    copySuccess() {
      this.$message.success($t('账户信息复制成功'))
    },
    sureBankPay() {
      this.$ajax(this.$url.bankpay(), {
        orderId: this.routerQuery.orderId,
        bankAccountNo: this.bankPay.bankAccountNo,
      }).then(res => {
        this.$router.push({
          path: '/MyOrder',
          query: {},
        })
      })
    },
    download() {
      this.loading = true
      this.$ajax(this.$url.downloadBankCert(), {
        orderId: this.routerQuery.orderId,
        bankAccountNo: this.bankPay.bankAccountNo,
        companyCode: this.orderInfo.companyCode,
      })
        .then(res => {
          if (res.data) {
            window.open(res.data)
            this.loading = false
            this.$message.success($t('证明文件生成完成'))
          } else {
            this.downloadAgain()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadAgain() {
      let countTime = 0
      this.bankclock = setInterval(() => {
        countTime++
        if (countTime > 30) {
          clearInterval(this.bankclock)
          this.$message.error($t('证明文件生成超时，请重试'))
          this.loading = false

          return
        }
        const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid
        this.$ajax(this.$url.getDownloadBankCertUrl(oid), { fileType: 4, businessCode: this.orderInfo.contractId })
          .then(res => {
            if (res.code === 20502002) {
              this.loading = false
              clearInterval(this.bankclock)
              this.$message.error(res.message)
              this.$router.push('/Myorder')
            } else if (res.data) {
              window.open(res.data)
              clearInterval(this.bankclock)
              this.loading = false
              this.$message.success($t('证明文件生成完成'))
            }
          })
          .catch(() => {
            clearInterval(this.bankclock)
            this.loading = false
          })
      }, 1000)
    },
    clearClock() {
      clearInterval(this.clock)
    },
    // 微信支付设置定时器查询状态
    setClock() {
      this.clock = setInterval(() => {
        this.$ajax(this.$url.getPayOrderDetail(this.payOrderId)).then(res => {
          if (res.data.status === 'PAY_SUCCESS') {
            this.reportSourceChannel('order_pay_success')
            this.$router.replace({
              path: '/result',
              query: {
                ...this.routerQuery,
                payOrderId: this.payOrderId,
                invoiceId: this.currentInvoiceId,
              },
            })
            this.clearClock()
          }
        })
      }, 2000)
    },
    // 页面初始化
    async pageInit() {
      if (this.routerQuery.orderId) {
        const orderInfo = await this.getOrderDetail()
        this.orderInfo = orderInfo.data
        const resExpressFee = await this.getFee()
        this.fee = resExpressFee.data ? resExpressFee.data.fee : 0
        this.amount += this.fee
        resExpressFee.data && (this.currentInvoiceId = resExpressFee.data.invoiceId)
        this.reportSourceChannel('to_pay_order')
      } else {
        this.currentInvoiceId = this.routerQuery.invoiceId
        this.amount += parseFloat(this.routerQuery.fee) || 0
      }
      if (this.userInfo.realName && this.userInfo.isAdmin) {
        const tempBalance = await this.getBalance()
        if (tempBalance.data.balance < this.amount) {
          this.paymentWay = 'other'
          this.hasBalance = true
        }
      } else {
        this.paymentWay = 'other'
        this.hasBalance = false
      }
    },
    // 获取订单快递费
    getFee() {
      const params = {}

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getExpressFee(this.routerQuery.orderId), params)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 获取用户余额
    async getBalance() {
      const params = {}

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getAccountWalletAmount(), params, false)
          .then(res => {
            const walletType = res.data.walletResultList.filter(item => item.walletType === 'DEFAULT')
            walletType.length > 0 && (this.myWallet = walletType[0].balance)
            resolve(res)
          })
          .catch(err => {
            this.paymentWay = 'other'
            reject(err)
          })
      })
    },
    // 获取订单详情
    async getOrderDetail() {
      const params = {}
      const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getOrderDetailByOrderId(this.routerQuery.orderId, oid), params)
          .then(async res => {
            if (res.code === 20502002) {
              this.$message.error(res.message)
              this.$router.push('/Myorder')
            } else {
              if (res.data.paymentType === 3) {
                this.isPostPaid = true
                await this.getTableList()
              } else {
                this.needPay = (res.data.price - res.data.amountPaid).toFixed(2)
                this.amount = res.data.price - res.data.amountPaid
              }
              resolve(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getTableList() {
      return new Promise((resolve, reject) => {
        const order = this.routerQuery.orderId
        this.$ajax(this.$url.volumes(order), {})
          .then(res => {
            this.tableData = res.data
            // 按量后付的话，重新赋值一下amount
            let tempAmount = 0
            res.data.forEach(val => {
              if (val.status !== 1) {
                tempAmount += parseFloat(val.produceCost) - parseFloat(val.amountPaid)
              }
            })
            this.needPay = tempAmount
            this.amount = tempAmount
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 换取payOrderId
    async getPayOrderId() {
      const params = {}
      params.fee = this.routerQuery.fee || this.fee || 0
      if (this.routerQuery.orderId) {
        params.objects = []
        const item = {
          orderId: this.routerQuery.orderId,
          price: this.needPay,
        }
        params.objects.push(item)
      }
      if (this.currentInvoiceId) {
        params.invoiceId = this.currentInvoiceId
      }
      let operation = ''
      if (this.routerQuery.orderId && this.currentInvoiceId) {
        operation = 'PAY_WITH_INVOICE'
      } else if (this.routerQuery.orderId && !this.currentInvoiceId) {
        operation = 'PAY_FOR_ORDER'
      } else {
        operation = 'PAY_FOR_INVOICE'
      }
      params.operation = operation

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getPayorderId(), params)
          .then(res => {
            this.payOrderId = res.data
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 余额支付
    async walletPay() {
      const params = {}
      params.password = MD5(this.signPassword)

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.walletPay(this.payOrderId), params).then(() => {
          this.reportSourceChannel('order_pay_success')
          this.$router.replace({
            path: '/result',
            query: {
              ...this.routerQuery,
              payOrderId: this.payOrderId,
              invoiceId: this.currentInvoiceId,
            },
          })
        })
      })
    },
    // 选择第三方支付方式
    handlePaymentOthWayClick(arg) {
      this.paymentOthWay = arg
    },
    async thirdPay() {
      const params = {}
      params.type = this.paymentOthWay
      params.payOrderId = this.payOrderId
      const returnUrl = window.location.origin

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.thirdPartPay(params.type, params.payOrderId), { returnUrl })
          .then(res => {
            this.apply = res.data
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 确认支付
    // eslint-disable-next-line consistent-return
    handleConfirmPayment: debounce(
      async function handleConfirmPayment() {
        if (this.paymentOthWay === 'bank' && this.paymentWay !== 'balance') {
          this.loadingStatus = true
          this.openBankPay('bank')
          this.$reportBusiness('business_monitor_event_start', 'order_pay', {
            appId: this.$route.query.appid,
            ouid: this.userInfo.gid,
            orgId: this.userInfo.orgId,
            paymentWay: this.paymentWay,
            payOrderId: this.payOrderId,
            stage: 'RechargeOnline',
          })
        } else {
          await this.getPayOrderId()
          this.$reportBusiness('business_monitor_event_start', 'order_pay', {
            appId: this.$route.query.appid,
            ouid: this.userInfo.gid,
            orgId: this.userInfo.orgId,
            paymentWay: this.paymentWay,
            payOrderId: this.payOrderId,
            stage: 'RechargeOnline',
          })
          if (this.paymentWay === 'balance') {
            if (!this.signPassword) {
              this.$message({
                type: 'info',
                message: $t('请输入签署密码进行支付'),
              })

              return false
            }
            await this.walletPay()
            this.reportSourceChannel('order_pay_success')

            this.$router.replace({
              path: '/result',
              query: { ...this.routerQuery, invoiceId: this.currentInvoiceId },
            })
          } else if (this.paymentOthWay === 'alipay') {
            if (this.isDingtalk) {
              const resThirdPartPayment = await this.thirdPay()
              const div = document.createElement('div')
              /* 此处form就是后台返回接收到的数据 */
              div.innerHTML = resThirdPartPayment
              document.body.appendChild(div)
              document.forms[0].submit()
            } else {
              this.payTitle = $t('支付宝支付(请用支付宝扫描二维码)')
              this.QrCodePay('ALIPAY')
            }
          } else if (this.paymentOthWay === 'wei') {
            this.payTitle = $t('微信支付(请用微信扫描二维码)')
            this.QrCodePay('TENPAY')
          }
        }
      },
      2000,
      true
    ),

    safariWindowOpen(callback) {
      // 判断是否Safari浏览器
      callback().then(res => {
        this.reportSourceChannel('order_pay_success')
        window.open(res)
        this.$router.replace({
          path: '/result',
          query: {
            ...this.$router.currentRoute.query,
            payOrderId: this.payOrderId,
            invoiceId: this.currentInvoiceId,
          },
        })
      })
    },

    QrCodePay(thirdPayMode) {
      const data = {
        thirdPayMode,
        returnUrl: window.location.origin,
      }
      this.$ajax(this.$url.precreatePay(this.payOrderId), data).then(res => {
        this.qrCode = res.data.qrCode
        this.qrCodeDialogShow = true
        this.setClock()
      })
    },
    openBankPay(thirdPayMode) {
      this.loading = false
      this.$ajax(this.$url.createbankAccountNoPay(this.routerQuery.orderId), {})
        .then(res => {
          this.loadingStatus = false
          this.bankPay = res.data
          this.bankPayDialogShow = true
          this.copyValue = `
          ${$t('开户名称：')}${this.bankPay.companyName}
          ${$t('开户银行：')}${this.bankPay.bankName}
          ${$t('专属汇款账号：')}${this.bankPay.bankAccountNo}
          ${$t('付款金额：')}${this.amount?.toFixed(2) || '0.00'}${$t('元')}
        `
        })
        .catch(() => {
          this.loadingStatus = false
        })
    },
    // 打开list
    checkHistoryList() {
      this.historyBillListDialogShow = true
    },
    locationTo(arg) {
      window.open(arg)
    },
  },
}
</script>
<style lang="less" scoped>
#RechargeOnline {
  .balance-bar {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    padding: 0 24px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;

    .title {
      margin-right: 48px;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;

      .left {
        margin-right: 20px;
      }
    }

    .money {
      color: #ff0000ff;
      font-size: 24px;
    }
  }

  .diy-selecter-area {
    margin-top: 20px;

    .rower {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      p {
        height: 16px;
        margin-left: 20px;
        font-size: 14px;
      }
    }
  }

  .e-collapse-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 90px;

    .label {
      width: 60px;
      margin-right: 20px;
      font-size: 14px;
      color: #333333;
    }
  }

  .payment-way {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .payment-block {
      text-align: center;
      width: 200px;
      height: 50px;
      border: 1px solid #f3f3f3;
      margin-right: 20px;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 100%;
      }

      img.wei {
        width: 60%;
        margin-top: 10px;
      }

      &.bank {
        display: flex;
        justify-content: space-around;
        padding: 5px 30px;
      }
    }

    .active {
      border: 1px solid #0975e0ff;
    }
  }
}

.flex-row-start-center {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .explain {
    font-size: 14px;
    color: #333333;
    line-height: 26px;
    height: 26px;
    margin-left: 10px;
  }

  .a-link {
    color: #1875f0;
    text-decoration: underline;
    cursor: pointer;
  }
}

.width-200 {
  width: 200px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.a-link {
  color: #1875f0;
  text-decoration: underline;
  cursor: pointer;
}
/deep/ .es-empty__image {
  width: 64px;
}
</style>
